import vToast from "./v-toast.vue";

export default Vue => {
  Vue.component("v-toast", vToast);
};
